<template>
  <myDialog
      :isDialog="isDialog"
      title="批量修改案件"
      :width="'800px'"
      @handleClose="handleClose"
  >
    <template #content>
      <div class="tip">已选择 2 个案件进行批量修改</div>
      <el-form ref="formRef" :model="formData" :rules="rules" label-width="170px" class="add-case-form">
        <el-form-item label="批量修改承办人" prop="undertakerName">
          <el-input v-model="formData.undertakerName" placeholder="请输入承办人姓名"/>
        </el-form-item>
        <el-form-item label="案件分类" prop="caseTypeCode">
          <el-select v-model="formData.applicationYear" placeholder="请选择类型">
            <el-option
                v-for="item in caseClassificationOptions"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="案件分类" prop="caseTypeCode">
          <el-select v-model="formData.insuredConditionCode" placeholder="请选择参保情况" clearable
                     style="width: 100%;">
            <el-option
                v-for="item in insuranceStatusOptions"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="与关联单位关系">
          <el-select v-model="formData.unitRelationCode" placeholder="请选择与关联单位关系" clearable
                     style="width: 100%;">
            <el-option
                v-for="item in relationWithUnitOptions"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <template>
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确认修改</el-button>
      </template>
    </template>
  </myDialog>
</template>

<script>
import {getListByDictType} from "@/api/sys/dictData";

export default {
  name: "batchEdit",
  props: {
    type: {
      type: Number,
      default: 1
    },
    isDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: {
        applicationYear: '',
        caseCode: '',
      },
      rules: {},
      submitLoading: false,
      caseClassificationOptions: [],
      insuranceStatusOptions: [],
      relationWithUnitOptions: []
    }
  },
  created() {
    this.loadDictData()
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {

        }
      })
    },
    async loadDictData() {
      const dictTypes = [
        {key: 'caseClassificationOptions', type: 'industrial_injury_case_classification'},
        {key: 'insuranceStatusOptions', type: 'industrial_injury_insurance_status'},
        {key: 'relationWithUnitOptions', type: 'industrial_injury_relation_with_unit'},
      ]
      for (const {key, type} of dictTypes) {
        try {
          const res = await getListByDictType(type)
          if (res && res.code === 200 && res.data) {
            this[key] = res.data
          }
        } catch (e) {
          console.warn(`字典 ${type} 加载失败`, e)
        }
      }
    },
  }
}
</script>

<style scoped>
.tip {
  height: 44px;
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-shrink: 0;
  padding: 8px 16px;
  border-radius: 4px;
  background: rgba(254, 237, 238, 1);
  color: rgba(255, 62, 80, 1);
  font-family: "Alibaba PuHuiTi 3.0";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 10%;
  text-align: center;
  margin-bottom: 16px;
}
/deep/ .el-dialog__header {
  background: #297dee !important;
}
/deep/ .el-dialog__title {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 17px;
}
/deep/ .el-dialog__headerbtn {
  filter: brightness(0) invert(1) !important;
}
</style>